export const ELECTRICAL_COLORS: Record<string, string> = {
  power: 'rgb(255, 0, 0)',
  neutral: 'rgb(128, 128, 128)',
  ground: 'rgb(0, 255, 0)',
  data: 'rgb(0, 0, 255)',
  highlight: 'rgb(255, 255, 0)',
};

export const HIT_BOX_PADDING = 0;
